
import { constants } from "../constants/redux-constants";

const initialState = {
  availableLocations: [],
  selectedLocation: { id: null, name: null },
};

const LocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants?.LOCATION?.SET_AVAILABLE_LOCATIONS:
      return {
        ...state,
        availableLocations: action?.payload,
      };
    case constants?.LOCATION?.SET_SELECTED_LOCATION:
      return {
        ...state,
        selectedLocation: action?.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default LocationReducer;
